import { format } from 'date-fns';
import { Timestamp } from 'firebase/firestore';
import { CustomTableUsers, UserTableHeadersText } from '../interfaces';

export const generatePromoPrefix = () => {
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let voucher = '';

  for (let i = 0; i < 4; i++) {
    const randomIndex = Math.floor(Math.random() * alphabet.length);
    voucher += alphabet.charAt(randomIndex);
  }

  return voucher;
};

export const splitPromoPrefix = (inputString: string): string[] => {
  const dashIndex = inputString.indexOf('-');

  if (dashIndex !== -1) {
    const firstPart = inputString.substring(0, dashIndex + 1);
    const secondPart = inputString.substring(dashIndex + 1);

    return [firstPart, secondPart];
  } else {
    return [];
  }
};

export const latestReflection = (a?: Timestamp, b?: Timestamp): number => {
  if (a && b) {
    if (a.toMillis() > b.toMillis()) {
      return a.toMillis();
    } else {
      return b.toMillis();
    }
  } else if (a && !b) {
    return a.toMillis();
  } else if (!a && b) {
    return b.toMillis();
  } else {
    return 0;
  }
};

export const convertArrayOfObjectsToCSV = (data: CustomTableUsers[]) => {
  const headers = Object.keys(data[0])
    .map((i) => UserTableHeadersText[i as keyof CustomTableUsers])
    .join(',');
  const csvData = data
    .map((item) =>
      [
        item.uid,
        item.email,
        item.name ?? '',
        format(new Date(item.createdAt), 'yyyy-MM-dd  HH:mm'),
        item.latestReflection ? format(new Date(item.latestReflection), 'yyyy-MM-dd  HH:mm') : 'Ej slussat',
        item.nrOfCoins,
        item.subscription === 'APPLE'
          ? 'Apple'
          : item.subscription === 'GOOGLE'
          ? 'Google'
          : item.subscription
          ? 'Stripe:' + item.subscription.stripeLink
          : 'Ej prenumeration',
        `"${item.organisations.map((o) => o.orgName).toString()}"`,
        item.treasures
      ].join(',')
    )
    .join('\n');
  return `${headers}\n${csvData}`;
};

export const exportToCSV = (data: CustomTableUsers[], fileName: string) => {
  const csv = convertArrayOfObjectsToCSV(data);
  const blob = new Blob([csv], { type: 'text/csv' });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName + '.csv';
  link.click();
};
